// extracted by mini-css-extract-plugin
export default {"melodyVideo":"IK-z","isFullWidth":"JK-z","landingPageVideo":"KK-z","play":"LK-z","iframeVideo":"MK-z","playHidden":"NK-z","fullwidth":"OK-z"};